import { useContext } from 'react';

import { AuthContext } from './AuthContext';

export default function useAuthState() {
  return useContext(AuthContext);
}
